import * as momentNs from 'moment';
const moment = momentNs;

export class WorkingHours {

  public isEditable = false;

  public get startTime() {
    return moment(this.startHour + ':' + this.startMinute, 'HH:mm').format('HH:mm');
  }

  public set startTime(value) {
    const endTime = this.endTime;

    const time =  value.split(':');

    this.startHour = time[0];
    this.startMinute = time[1];

    this.endTime = endTime;
  }

  public get endTime() {
    return moment(this.startHour + ':' + this.startMinute, 'HH:mm').add(Number(this.duration), 'minutes').format('HH:mm');
  }

  public set endTime(value: string) {
    const time =  value.split(':');

    const startTime = moment(this.startHour + ':' + this.startMinute, 'HH:mm');
    const endTime = moment(time[0] + ':' + time[1], 'HH:mm');

    this.duration = endTime.diff(startTime, 'minutes').toString();
  }

  public isFree(): boolean {
    return !this.startHour && !this.startMinute && !this.duration;
  }

  constructor(public startHour: string,
              public startMinute: string,
              public duration: string) {
  }
}
